export const MISSING_DIR_OR_EMPTY_PROJECT = '1'
export const EXISTING_CONFIG = '2'
export const MISSING_CONFIG = '3'
export const FAILED_CONFIG_READ = '4'
export const TAILWIND_NOT_CONFIGURED = '5'
export const IMPORT_ALIAS_MISSING = '6'
export const UNSUPPORTED_FRAMEWORK = '7'
export const COMPONENT_URL_NOT_FOUND = '8'
export const COMPONENT_URL_UNAUTHORIZED = '9'
export const COMPONENT_URL_FORBIDDEN = '10'
export const COMPONENT_URL_BAD_REQUEST = '11'
export const COMPONENT_URL_INTERNAL_SERVER_ERROR = '12'
export const BUILD_MISSING_REGISTRY_FILE = '13'
